module.exports = __webpack_public_path__ + "img/wha.147a5f4c.png";